// import { Link } from 'react-router-dom';
import cartIcon from '../../assets/icons/LayoutIcons/cart.svg';
import notificationIcon from '../../assets/icons/LayoutIcons/notification.svg';
import messageIcon from '../../assets/icons/DashboardIcons/message.png';

const MobileFooter = () => {
  return (
    <footer className='bg-[#F4F4F4] px-4 py-3'>
      <div className='flex-1 flex items-center justify-between space-x-4'>
        <div className='text-center'>
          <img src={messageIcon} className='w-[24px]' alt='cart-icon' />
          <h4 className='font-poppins font-normal text-xs text-black'>Message</h4>
        </div>
        <div className='text-center'>
          <img src={cartIcon} className='w-[24px]' alt='cart-icon' />
          <h4 className='font-poppins font-normal text-xs text-black'>Cart</h4>
        </div>
        <div className='relative text-center'>
          <div className='absolute bg-[#F51010] top-[-1px] right-[24px] rounded-lg w-[10px] h-[10px]'></div>
          <img src={notificationIcon} className='w-[14px]' alt='notification' />
          <h4 className='font-poppins font-normal text-xs text-black'>Notification</h4>
        </div>
      </div>
    </footer>
  );
};

export default MobileFooter;
